import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {LocalStorageAssistantRepository} from '../Repositories/LocalStorageAssistantRepository.js'

class GetAllAssistantChatsUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new GetAllAssistantChatsUseCase({
      repository: LocalStorageAssistantRepository.create({config})
    })
  }

  @tracer({metric: 'GetAllAssistantChatsUseCase#execute'})
  @AsyncInlineError()
  async execute({resetLoading = false} = {}) {
    return this.#repository.getAllChats({resetLoading})
  }
}

export const factory = GetAllAssistantChatsUseCase.create
